function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" {...props}><title>Group 2 Copy</title><g fill="none" fillRule="evenodd"><circle stroke="#5AB457" strokeWidth="9" fill="#5AB457" cx="30" cy="30" r="25.5" /><path stroke="#FFF" strokeWidth="5.4" strokeLinecap="round" strokeLinejoin="round" d="M45 21L25.974 42 15 31.5" /></g></svg>;
});